<template lang="pug">
  .pwd
    input(
      ref="input"
      type="password"
      v-model="value"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      @input="onChange"
    )
    .pwd__visibility-icon
      font-awesome-icon.pwd__icon(
        icon="eye"
        v-on:click="togglePwd"
        v-if="!pwdVisible"
      )
      font-awesome-icon.pwd__icon(
        icon="eye-slash"
        v-on:click="togglePwd"
        v-else
      )
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faEye);
library.add(faEyeSlash);

export default {
  props: {
    autocomplete: {
      required: false,
      type: String,
      default: 'off'
    },
    placeholder: {
      required: false,
      type: String,
      default: 'Пароль'
    },
    name: {
      required: false,
      type: String,
      default: 'new-password'
    }
  },

  data() {
    return {
      pwdVisible: false,
      value: ''
    };
  },

  methods: {
    togglePwd() {
      if (this.pwdVisible) {
        this.hidePwd();
      } else {
        this.showPwd();
      }
      this.$emit('togglePwdVisibility', this.pwdVisible);
    },

    setPwdVisibility(state) {
      if (state) {
        this.showPwd();
      } else {
        this.hidePwd();
      }
    },

    showPwd() {
      this.$refs.input.type = 'text';
      this.pwdVisible = true;
    },

    hidePwd() {
      this.$refs.input.type = 'password';
      this.pwdVisible = false;
    },

    onChange() {
      this.$emit('input', this.value);
    }
  },

  components: {
    FontAwesomeIcon
  }
};
</script>

<style lang="scss" scoped>
.pwd {
  position: relative;

  &__visibility-icon {
    position: absolute;
    top: 50%;
    margin-top: -12px;
    right: 8px;
    cursor: pointer;
  }

  &__icon {
    width: 16px;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
